/**
 * @generated SignedSource<<7b34c9111ea758b2d0c58104cdf1f227>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiCreditsPolicyDialogQuery$variables = Record<PropertyKey, never>;
export type aiCreditsPolicyDialogQuery$data = {
  readonly aiCreditsPolicyStatus: {
    readonly accepted: boolean | null;
    readonly dialogRequired: boolean;
  };
};
export type aiCreditsPolicyDialogQuery = {
  response: aiCreditsPolicyDialogQuery$data;
  variables: aiCreditsPolicyDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AICreditsPolicyStatus",
    "kind": "LinkedField",
    "name": "aiCreditsPolicyStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accepted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dialogRequired",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCreditsPolicyDialogQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiCreditsPolicyDialogQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "1d7c7b70fa18bc2066d8f790d6d81f8d",
    "id": null,
    "metadata": {},
    "name": "aiCreditsPolicyDialogQuery",
    "operationKind": "query",
    "text": "query aiCreditsPolicyDialogQuery {\n  aiCreditsPolicyStatus {\n    accepted\n    dialogRequired\n  }\n}\n"
  }
};
})();

(node as any).hash = "b23cce8d7b56c5aa98b0f8fb41b0beb7";

export default node;
